import React, { useMemo, useState } from "react";
import "./Gdmebe.css";

const TABS = [
  { key: "do-dung", label: "ĐỒ DÙNG CHO BÉ" },
  { key: "do-choi", label: "ĐỒ CHƠI CHO BÉ" },
  { key: "hoc-tap", label: "DỤNG CỤ HỌC TẬP" },
  { key: "an-dam", label: "PHỤ KIỆN ĂN DẶM" },
];

const ALL = [
  {
    id: 1,
    tab: "do-choi",
    qty: 48,
    name: "Bộ Đồ Chơi Balo cho bé 10ct No:2501",
    price: 65900,
    img: "/4mb/1.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 2,
    tab: "do-choi",
    qty: 48,
    name: "Bộ Đồ Chơi Nấu Ăn 13ct Dream Kitchen No599",
    price: 61100,
    img: "/4mb/2.jpeg",
    href: "#",
  },
  {
    id: 3,
    tab: "do-dung",
    qty: 30,
    name: "Bô cho bé họa tiết gà con",
    price: 48300,
    img: "/4mb/3.jpeg",
    href: "#",
  },
  {
    id: 4,
    tab: "an-dam",
    qty: 75,
    name: "Bình nước trẻ em 0106",
    price: 6600,
    img: "/4mb/4.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 5,
    tab: "do-choi",
    qty: 18,
    name: "Bộ Đồ Chơi Nhà Bếp (full set)",
    price: 89900,
    img: "/4mb/5.jpeg",
    href: "#",
    soldOut: true,
  },
  {
    id: 6,
    tab: "hoc-tap",
    qty: 40,
    name: "Bàn Chải Đánh Răng Trẻ Em (combo)",
    price: 12900,
    img: "/4mb/6.jpeg",
    href: "#",
  },
  {
    id: 7,
    tab: "do-dung",
    qty: 22,
    name: "Ghế Ngồi Cho Bé (mini)",
    price: 39900,
    img: "/4mb/7.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 8,
    tab: "hoc-tap",
    qty: 16,
    name: "Khay Đựng Đồ / Tủ Mini",
    price: 55900,
    img: "/4mb/8.jpeg",
    href: "#",
    cornerIcon: true,
  },
];

function formatVND(n) {
  return new Intl.NumberFormat("vi-VN").format(n) + "đ";
}

export default function Gdmebe() {
  const [tab, setTab] = useState(TABS[0].key);

  const products = useMemo(() => {
    const filtered = ALL.filter((p) => p.tab === tab);
    // luôn hiển thị đủ 8 ô: nếu thiếu thì bù bằng sản phẩm khác
    if (filtered.length >= 8) return filtered.slice(0, 8);
    const rest = ALL.filter((p) => p.tab !== tab);
    return [...filtered, ...rest].slice(0, 8);
  }, [tab]);

  return (
    <section className="mb">
      <div className="mb__container">
        <div className="mb__head">
          <h2 className="mb__title">ĐỒ MẸ &amp; BÉ</h2>

          <div
            className="mb__tabs"
            role="tablist"
            aria-label="Danh mục đồ mẹ & bé"
          >
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`mb__tab ${tab === t.key ? "is-active" : ""}`}
                onClick={() => setTab(t.key)}
                role="tab"
                aria-selected={tab === t.key}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mb__grid">
          {products.map((p) => (
            <a className="mb__card" href={p.href} key={p.id}>
              <div className="mb__media">
                <img
                  className="mb__img"
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                />

                {p.cornerIcon && (
                  <span className="mb__cornerIcon" aria-hidden="true" />
                )}

                {p.soldOut && (
                  <span className="mb__soldOut" aria-label="Tạm hết">
                    Tạm hết
                  </span>
                )}
              </div>

              <div className="mb__meta">
                <div className="mb__name">
                  <span className="mb__qty">[{p.qty}]</span>{" "}
                  <span className="mb__nameText">{p.name}</span>
                </div>
                <div className="mb__price">{formatVND(p.price)}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
